import * as React from 'react';
import '../css/service-card.sass';
import Card from './Card';
import Anchor from './Anchor';
import Amount from './Amount';
import HtmlContent from './HtmlContent';

interface ServiceCardProps {
  id: string;
  category: string;
  name: string;
  price: number;
  priceLabel?: string;
  detailsLinkUrl?: string;
  detailsLinkLabel?: string;
  theme?: 'night' | 'day';
}

export default function ServiceCard(props: ServiceCardProps) {
  const {
    theme = 'day',
    priceLabel = 'per month',
    detailsLinkLabel = 'See Details'
  } = props;
  return (
    <div className="service-card">
      <Card theme={theme}>
        <div className="type">{props.category}</div>
        <div className="name">
          <HtmlContent html={props.name} />
        </div>
        <div className="price">
          <Amount amount={props.price} />
          <div className="label">{priceLabel}</div>
        </div>
        {props.detailsLinkUrl && (
          <div className="link">
            <Anchor
              arialabel={props.name}
              id={props.id}
              href={props.detailsLinkUrl}
              theme={theme}
              forward
            >
              {detailsLinkLabel}
            </Anchor>
          </div>
        )}
      </Card>
    </div>
  );
}
